import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { JobEditorBaseRouting } from '@apps/job-editor';
import { CustomerPackageBuilderRouting } from '@apps/customer-package-builder';
import { CustomerCartRoutes } from '@apps/cart';
import { CheckoutRoutes } from '@apps/checkout';
import { AdminRouting } from './apps/admin';
import { CustomerRouting, DigitalRoute } from './apps/customer';
import { StudioAdminRouting } from './apps/studioadmin';
import { AccountRouting } from './apps/account';
import { HomeRouting } from './apps/home';

const CUSTOMER_AREA: RouteRecordRaw = {
  path: '/:studioSlug',
  component: () => import('./apps/customer/layouts/CustomerLayout.vue'),
  children: [...CustomerRouting, ...CustomerPackageBuilderRouting, ...CustomerCartRoutes, ...CheckoutRoutes],
};

const ACCOUNT_AREA: RouteRecordRaw = {
  path: '/account',
  component: () => import('./apps/account/layouts/AccountLayout.vue'),
  children: [...AccountRouting],
};

const HOME_AREA: RouteRecordRaw = {
  path: '/',
  component: () => import('./apps/home/layouts/HomeLayout.vue'),
  children: [...HomeRouting, ...DigitalRoute],
};

const MAINTENANCE_AREA: RouteRecordRaw = {
  path: '/maintenance',
  component: () => import('./shared/pages/MaintenancePage.vue'),
};

const routes: RouteRecordRaw[] = [
  HOME_AREA,
  ...AdminRouting,
  ...StudioAdminRouting,
  ...JobEditorBaseRouting,

  CUSTOMER_AREA,
  ACCOUNT_AREA,
  MAINTENANCE_AREA,
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

const setDocumentTitle = (route: RouteLocationNormalized) => {
  const suffix = 'My Pro Images';
  const title = route.meta.title;
  document.title = title ? `${title} | ${suffix}` : suffix;
};

router.beforeEach((to, from, next) => {
  setDocumentTitle(to);
  next();
});
export { router };

declare module 'vue-router' {
  interface RouteMeta {
    breadCrumb?: {
      label: string;
      icon?: IconDefinition;
    };
  }
}
